import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // null means "not checked yet"
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = Cookies.get("auth_token");
    const userCookie = Cookies.get("user");

    if (token && userCookie) {
      try {
        const parsedUser = JSON.parse(userCookie);
        setIsLoggedIn(true);
        setUserProfile(parsedUser);
      } catch (error) {
        console.error("Failed to parse user cookie:", error);
        Cookies.remove("user"); // remove corrupted data
        setIsLoggedIn(false);
        setUserProfile(null);
      }
    }
    setLoading(false);
  }, []);

  const login = (user, token) => {
    setIsLoggedIn(true);
    setUserProfile(user);

    // Set cookies
    Cookies.set("auth_token", token, {
      expires: 7,
      secure: true,
      sameSite: "Strict",
    });

    Cookies.set("user", JSON.stringify(user), {
      expires: 7,
      secure: true,
      sameSite: "Strict",
    });
  };

  const logout = () => {
    Cookies.remove("auth_token");
    Cookies.remove("user");
    setIsLoggedIn(false);
    setUserProfile(null);
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, userProfile, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
